export default {
  get_all: { method: "get", url: "api/moedas" },
  show: { method: "get", url: "api/moedas{/id}" },
  store: { method: "post", url: "api/moedas" },
  update: { method: "put", url: "api/moedas{/id}" },
  delete: { method: "delete", url: "api/moedas{/id}" },
  to_select: { method: "get", url: "api/moedas/to-select" },
};
